import Axios, { AxiosResponse } from "axios"
import { ActionLogQueryState, ActionLogResponse } from "./action-log.type"
import { EncryptionKeys } from "controllers/EncryptionController"
import { getPrivateKeyByUserId } from "helpers/utils"
import { encryptionGCMHelper } from "helpers/encryption-gcm"
import { activityLogHelper } from "helpers/activity_log"
import { DECRYPTION_BLOCKED_CONTENT } from "helpers/decryptionBlocked"
import {
  captureSentryEncryptionEvent,
  generateTRCCode,
} from "helpers/sentryMonitoring"

export const getActionLogMiddleware = async (params: ActionLogQueryState) => {
  try {
    const response: AxiosResponse<{
      data: {
        logs: ActionLogResponse[]
        projects: {
          id: string
          name: string
          code: string
        }[]
      }
    }> = await Axios.get("/api/activity-log-advanced", {
      params,
    })
    const userVaultKey = localStorage.getItem(
      EncryptionKeys.userVaultKey
    ) as string
    const privateKeyPem: any = await getPrivateKeyByUserId()
    const projects = response.data.data.projects
    const logs = await Promise.all(
      response.data.data.logs.map(async (item) => {
        let content = item.content
        let decryptKey = ""
        if (item.encryptedKey) {
          if (item.isShareKey) {
            decryptKey = privateKeyPem.decrypt(item.encryptedKey, "RSA-OAEP")
          } else {
            decryptKey = await encryptionGCMHelper.decryptContext(
              userVaultKey,
              item.encryptedKey
            )
          }
        }
        if (decryptKey !== item.encryptedKey) {
          const originalContent = content
          content = (await encryptionGCMHelper.decryptContext(
            decryptKey,
            content
          )) as string
          if (content === originalContent) {
            const trcCode = generateTRCCode("DEC")
            captureSentryEncryptionEvent("Content decryption failed - WRONG_VALUE", {
              error_category: "DEC",
              error_type: "WRONG_VALUE",
              workspace_id: localStorage.getItem("last_organization_db_name") || "",
              error_code: trcCode,
              step_trail: "action-log.api → getActionLogMiddleware",
            })
            content = DECRYPTION_BLOCKED_CONTENT
          }
        }
        if (item.param) {
          content = activityLogHelper.createStringFromTemplate(
            content,
            JSON.parse(item.param)
          )
        }
        return {
          ...item,
          content,
        }
      })
    )
    return {
      projects,
      logs,
    }
  } catch (error) {
    return {
      projects: [],
      logs: [],
    }
  }
}
